import { render, staticRenderFns } from "./PatrimonioListagem.vue?vue&type=template&id=3fa525ac&scoped=true&"
import script from "./PatrimonioListagem.vue?vue&type=script&lang=js&"
export * from "./PatrimonioListagem.vue?vue&type=script&lang=js&"
import style0 from "./PatrimonioListagem.vue?vue&type=style&index=0&id=3fa525ac&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa525ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VContainer,VFlex,VIcon,VTooltip})
